function parallaxOnScroll(selector, scale = 1) {
  const element = document.querySelector(selector);

  if (!element) return; // brak elementu

  window.addEventListener("scroll", () => {
    const distance = window.scrollY * -0.2;
    element.style.transform = `translateY(${distance * scale}px)`;
  });
}

// użycie:
parallaxOnScroll(".intro", 0.3);
parallaxOnScroll(".intro_cnt", 0.8); 